import { useLocation, useNavigate } from "react-router-dom";
import useCategories from "../../../../utils/useCategories";
import { useSelector } from "react-redux";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../_utils/CommonToast";
import ICONS from "../../../../assets/Icons";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";
import TextWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithBank";
import formatDateViewAll from "../../../../utils/formatDateViewAll";

const BeneTransactionGridView = ({
  data,
  isSidebarOpen,
  isDistributionPopoverOpen,
  isPopoverOpen,
  typepop,
  type,
  onClose,
  currentStatus,
  labelTransactions,
  setLabelTransactions,
  isLabelClicked,
  Labeldata,
  setLabeldata,
  filterRef,
  openTransHistory,
  similarTxn,
}) => {
  const navigate = useNavigate();
  const categoryMapper = useCategories();
  const benealldata = data;
  const location = useLocation();

  const services = useSelector((state) => state.refreshToken.services);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--awaiting)";
      case "denied":
      case "failed":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "rejected":
        return "var(--failed)";
      case "hold":
        return "var(--queued)";
      case "queued":
        return "var(--queued)";
      default:
        return "var(--settled)";
    }
  };

  const getDistriStatusColor = (status) => {
    switch (status) {
      case "awaiting_verification":
      case "awaiting_funds":
      case "distribution_initiated":
      case "created":
      case "distribution_pending":
      case "approved":
        return "var(--queued)";
      case "denied":
      case "failed":
      case "rejected":
        return "var(--failed)";
      case "abandoned":
        return "var(--abandoned)";
      case "distribution_complete":
        return "var(--settled)";
      default:
        return "var(--text-primary)";
    }
  };

  return (
    <div
      className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${isSidebarOpen ? "sidebar-open" : ""}`}
    >
      {benealldata?.map((transactions) => {
        return (
          <>
            <CardContainer
              filterRef={filterRef}
              hoverHeight={GlobalConfiguration?.beneTxnCardHoverHeight}
              minHeight={GlobalConfiguration.BeneTxnCardMinHeight}
              key={transactions?.txn_id}
              isSelected={
                Array.isArray(labelTransactions) &&
                labelTransactions.includes(transactions?.txn_id)
              }
              onClickHandler={() => {
                const txnDetailsPath = `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${transactions.txn_id}`;
                if (type === "bene_account_detail_modal") {
                  CommonToast({
                    text: "Action restricted in popup mode.",
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                  });
                  return;
                }

                const options =
                  transactions?.lifecycle_status === "pending" &&
                  services?.includes("ABeneficiaryTxn")
                    ? {
                        state:
                          currentStatus === "require approval"
                            ? "require approval"
                            : transactions?.lifecycle_status,
                      }
                    : {};

                if (similarTxn === "similarTxn") {
                  CommonToast({
                    text: "Action restricted in popup mode.",
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                  });
                  return;
                }
                if (typepop === "transactionHistorypopup" && !isLabelClicked) {
                  onClose();
                  navigate(txnDetailsPath, {
                    state: {
                      isViewAll:
                        location.pathname ===
                        "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                          ? true
                          : false,
                    },
                  });
                  window.location.reload();
                  return;
                }
                if (isLabelClicked) {
                  const isAlreadySelected = labelTransactions.includes(
                    transactions.txn_id,
                  );
                  if (isAlreadySelected) {
                    setLabelTransactions(
                      labelTransactions.filter(
                        (id) => id !== transactions.txn_id,
                      ),
                    );
                  } else {
                    setLabelTransactions([
                      ...labelTransactions,
                      transactions.txn_id,
                    ]);
                    setLabeldata([...Labeldata, transactions]);
                  }
                  return;
                }

                if (
                  !isSidebarOpen &&
                  !isPopoverOpen &&
                  !isDistributionPopoverOpen
                ) {
                  if (openTransHistory) {
                    onClose();
                  }
                  navigate(txnDetailsPath, {
                    replace: openTransHistory ? true : false,
                    state: {
                      isViewAll:
                        location.pathname ===
                        "/beneficiary_transaction_dashboard/beneficiary_transaction_view_all"
                          ? true
                          : false,
                      options: options,
                    },
                  });
                }
              }}
            >
              <card-body>
                <TextWithIcon
                  type={"Amount"}
                  fontWeight={"semibold"}
                  text={transactions?.amount}
                  subText={"Transaction amount"}
                  textColor={"var(--settled)"}
                  iconComponentArray={[
                    ...(transactions?.confidential_transaction === "Y"
                      ? [
                          {
                            icon: "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg",
                            title: "confidential",
                            isDisabled: false,
                          },
                        ]
                      : []),
                    ...(isLabelClicked
                      ? [
                          {
                            icon:
                              Array.isArray(labelTransactions) &&
                              labelTransactions.includes(transactions?.txn_id)
                                ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                                : "https://q2pay.in/new_assets/common/view_all/not_selected_with_grey_circle.svg",
                            isDisabled: false,
                          },
                        ]
                      : []),
                  ]}
                />

                <TextWithIcon
                  text={transactions.beneficiary_account_name
                    .toLowerCase()
                    .split(" ")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ")}
                  type={"Text"}
                  subText={"Beneficiary name"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                />
                <TextWithBank
                  text={
                    transactions.created_on
                      ? formatDateViewAll(transactions.created_on, false, false)
                      : "Not given"
                  }
                  subText={"Created on"}
                  type={"Text"}
                  src={categoryMapper(transactions.category)}
                  ifscCode={transactions.beneficiary_account_ifsc_code}
                />
              </card-body>

              <card-hover>
                <TextWithIcon
                  text={
                    currentStatus === "require approval"
                      ? "Require approval"
                      : transactions?.lifecycle_status || "N/A"
                  }
                  subText={"Approval status"}
                  textCase={"capitalize"}
                  fontWeight={"semibold"}
                  textColor={
                    transactions?.lifecycle_status === "N/A"
                      ? "var(--text-primary)"
                      : getStatusColor(transactions?.lifecycle_status)
                  }
                />

                <TextWithIcon
                  text={
                    transactions?.distribution_lifecycle_status === "created"
                      ? "Distribution created"
                      : transactions?.distribution_lifecycle_status ===
                          "awaiting_funds"
                        ? "Awaiting funds"
                        : transactions?.distribution_lifecycle_status ===
                            "distribution_initiated"
                          ? "Distribution initiated"
                          : transactions?.distribution_lifecycle_status ===
                              "abandoned"
                            ? "Distribution abandoned"
                            : transactions?.distribution_lifecycle_status ===
                                "rejected"
                              ? "Distribution rejected"
                              : transactions?.distribution_lifecycle_status ===
                                  "failed"
                                ? "Distribution failed"
                                : transactions?.distribution_lifecycle_status ===
                                    "distribution_complete"
                                  ? "Distribution complete"
                                  : transactions?.distribution_lifecycle_status ===
                                      "approved"
                                    ? "Distribution approved"
                                    : transactions?.distribution_lifecycle_status ||
                                      "N/A"
                  }
                  subText={"Distribution status"}
                  // textCase={"capitalize"}
                  fontWeight={"semibold"}
                  textColor={
                    transactions?.distribution_lifecycle_status === "N/A"
                      ? "var(--text-primary)"
                      : getDistriStatusColor(
                          transactions?.distribution_lifecycle_status,
                        )
                  }
                />

                <TextWithIcon
                  text={
                    transactions?.labels?.join(", ") || "No labels assigned "
                  }
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: "https://q2pay.in/new_assets/common/view_all/label.svg",
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          </>
        );
      })}
    </div>
  );
};

export default BeneTransactionGridView;
